/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const ACTIVITY_LIMIT = 6; // activity画面、1ページあたりの表示数

const RELOAD_TIME = 1 * 60 * 1000; // １分

const initialState = () => ({
  isLoggedIn: false, // ログイン中
  isConfirmed: false, // 子アカウント認証済み
  loginType: "", // ログインタイプ
  functionType: "", // 見える化 or ES
  loginID: "", // ログインID
  childID: "", // 子ID
  childInfo: null, // 子アカウント情報
  parentID: "", // 親ID
  beforeAct: "", //前アクション情報
  graphID : "",
  activity: {
    index: 1, // activity画面のページ目
    numOfPages: 0, // activity画面のページ数
    limit: ACTIVITY_LIMIT // activity画面、1ページあたりの表示数
    // numOfItems: 0, // activity画面、1ページあたりの表示数
  },
  accountList: {
    index: 1, // account画面のページ目
    numOfPages: 0, // account画面のページ数
    limit: ACTIVITY_LIMIT // account画面、1ページあたりの表示数
    // numOfItems: 0, // activity画面、1ページあたりの表示数
  },
  currentPower: 0,
  demandPower: 0,
  maxPower: 0,
  activitylist: [],
  salesCenterMaster: [],
  salesOfficeMaster: [],
  weatherAreaRelationMaster: [],
  reloadTime: RELOAD_TIME, // リロードタイム
  monitoringDate: "", // モニタリングを開く際の日付
  alertLevelClass: "level1", // アラートレベルクラス
  maxPowerClass: "level1",
  demand_datetime: "",
  airConditionerIdFlag: false,
  supplyManagement: false,
  esInfo : {
    selectedDevice: 0
  },
  isLoading: false
});

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      filter: (mutation)=>{
        //console.log(mutation)
        if (mutation.type === "SET_DEVICE_COUNT") {
          return false;
        } else {
          return true;
        }
      }
    })
  ],
  state: {
    isLoggedIn: false, // ログイン中
    isConfirmed: false, // 子アカウント認証済み
    loginType: "", // ログインタイプ
    functionType: "", // 見える化 or ES
    loginID: "", // ログインID
    childID: "", // 子ID
    childInfo: null, // 子アカウント情報
    parentID: "", // 親ID
    beforeAct: "",
    graphID: "",
    activity: {
      index: 1, // activity画面のページ目
      numOfPages: 0, // activity画面のページ数
      limit: ACTIVITY_LIMIT // activity画面、1ページあたりの表示数
      // numOfItems: 0, // activity画面、1ページあたりの表示数
    },
    accountList: {
      index: 1, // account画面のページ目
      numOfPages: 0, // account画面のページ数
      limit: ACTIVITY_LIMIT // account画面、1ページあたりの表示数
      // numOfItems: 0, // activity画面、1ページあたりの表示数
    },
    currentPower: 0,
    demandPower: 0,
    maxPower: 0,
    activitylist: [],
    salesCenterMaster: [],
    salesOfficeMaster: [],
    weatherAreaRelationMaster: [],
    reloadTime: RELOAD_TIME,
    monitoringDate: "",
    alertLevelClass: "level1",
    maxPowerClass: "level1",
    demand_datetime: "",
    airConditionerIdFlag: false,
    supplyManagement: false,
    esInfo : {
      selectedDevice: 0
    },
    isLoading: false
  },
  mutations: {
    RESET(state) {
      const initial = initialState();
      Object.keys(initial).forEach(key => {
        state[key] = initial[key];
      });
    },
    LOGIN(state) {
      state.isLoggedIn = true;
    },
    LOGOUT(state) {
      state.isLoggedIn = false;
    },
    SET_LOGIN_TYPE(state, loginType) {
      state.loginType = loginType;
    },
    SET_FUNCTION_TYPE(state, functionType) {
      state.functionType = functionType;
    },
    SET_CONFIRM(state, obj) {
      state.isConfirmed = obj.isConfirmed;
    },
    SET_LOGIN_ID(state, id) {
      state.loginID = id;
    },
    SET_CHILD_ID(state, id) {
      state.childID = id;
    },
    SET_PARENT_ID(state, id) {
      state.parentID = id;
    },
    SET_BEFORE_ACT(state, value) {
      state.beforeAct = value;
    },
    SET_GRAPH_ID(state, id){
      state.graphID = id;
    },
    SET_ACTIVITY_PAGE_INDEX(state, value) {
      state.activity.index = value;
    },
    SET_ACTIVITY_NUM_OF_PAGES(state, value) {
      state.activity.numOfPages = value;
      state.activity.limit = ACTIVITY_LIMIT;
    },
    SET_CURRENT_POWER(state, value) {
      state.currentPower = value;
    },
    SET_DEMAND_POWER(state, value) {
      state.demandPower = value;
    },
    SET_MAX_POWER(state, value) {
      state.maxPower = value;
    },
    SET_CHILD_INFO(state, value) {
      state.childInfo = value;
    },
    SET_ACCOUNT_LIST_PAGE_INDEX(state, value) {
      state.accountList.index = value;
    },
    SET_ACCOUNT_LIST_NUM_OF_PAGES(state, value) {
      state.accountList.numOfPages = value;
      state.accountList.limit = ACTIVITY_LIMIT;
    },
    SET_ACTIVITY_LIST(state, value) {
      state.activitylist = value;
    },
    SET_SALES_CENTER_MASTER(state, value) {
      state.salesCenterMaster = value;
    },
    SET_SALES_OFFICE_MASTER(state, value) {
      state.salesOfficeMaster = value;
    },
    SET_WEATHER_AREA_RELATION_MASTER(state, value) {
      state.weatherAreaRelationMaster = value;
    },
    SET_MONITORING_DATE(state, value) {
      state.monitoringDate = value;
    },
    SET_ALERT_LEVEL_CLASS(state, value) {
      state.alertLevelClass = value;
    },
    SET_MAX_POWER_CLASS(state, value) {
      state.maxPowerClass = value;
    },
    SET_AIR_CONDITIONER_ID_FLAG(state, value) {
      state.airConditionerIdFlag = value;
    },
    SET_SUPPLY_MANAGEMENT(state, value) {
      state.supplyManagement = value;
    },
    SET_SELECTED_DEVICE(state, value) {
      state.esInfo.selectedDevice = value;
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    }
  },
  actions: {
    login(context, obj) {
      context.commit("LOGIN");
      context.commit("SET_LOGIN_TYPE", obj.loginType);
      context.commit("SET_FUNCTION_TYPE", obj.functionType);
    },
    logout(context) {
      context.commit("LOGOUT");
      context.commit("SET_LOGIN_TYPE", "");
      context.commit("SET_FUNCTION_TYPE", "");
      context.commit("SET_LOGIN_ID", "");
      context.commit("SET_CHILD_ID", "");
      context.commit("SET_PARENT_ID", "");
      context.commit("SET_BEFORE_ACT", "");
      context.commit("SET_GRAPH_ID", "");
    },
    setConfirm(context, obj) {
      context.commit("SET_CONFIRM", obj);
    },
    setLoginType(context, obj) {
      context.commit("SET_LOGIN_TYPE", obj);
    },
    setFunctionType(context, obj) {
      context.commit("SET_FUNCTION_TYPE", obj);
    },
    setLoginID(context, id) {
      context.commit("SET_LOGIN_ID", id);
    },
    setChildID(context, id) {
      context.commit("SET_CHILD_ID", id);
    },
    setParentID(context, id) {
      context.commit("SET_PARENT_ID", id);
    },
    setBeforeAct(context, value) {
      context.commit("SET_BEFORE_ACT", value);
    },
    resetBeforeAct(context) {
      context.commit("SET_BEFORE_ACT", "");
    },
    setGraphID(context, id) {
      context.commit("SET_GRAPH_ID", id);
    },
    setActivityPageIndex(context, index) {
      context.commit("SET_ACTIVITY_PAGE_INDEX", index);
    },
    activityPageReset(context, numOfItems) {
      // item数
      context.commit(
        "SET_ACTIVITY_NUM_OF_PAGES",
        Math.ceil(numOfItems / context.state.activity.limit)
      );
      context.commit("SET_ACTIVITY_PAGE_INDEX", 1);
    },
    activityPageNext(context) {
      if (context.state.activity.index < context.state.activity.numOfPages) {
        context.commit(
          "SET_ACTIVITY_PAGE_INDEX",
          context.state.activity.index + 1
        );
      }
    },
    activityPagePrev(context) {
      if (context.state.activity.index > 1) {
        context.commit(
          "SET_ACTIVITY_PAGE_INDEX",
          context.state.activity.index - 1
        );
      }
    },
    setCurrentPower(context, value) {
      context.commit("SET_CURRENT_POWER", value);
    },
    setDemandPower(context, value) {
      context.commit("SET_DEMAND_POWER", value);
    },
    setMaxPower(context, value) {
      context.commit("SET_MAX_POWER", value);
    },
    setChildInfo(context, childInfo) {
      context.commit("SET_CHILD_INFO", childInfo);
    },
    setAccountListPageIndex(context, index) {
      context.commit("SET_ACCOUNT_LIST_PAGE_INDEX", index);
    },
    accountListPageReset(context, numOfItems) {
      // item数
      context.commit(
        "SET_ACCOUNT_LIST_NUM_OF_PAGES",
        Math.ceil(numOfItems / context.state.accountList.limit)
      );
      context.commit("SET_ACCOUNT_LIST_PAGE_INDEX", 1);
    },
    accountListPageNext(context) {
      if (
        context.state.accountList.index < context.state.accountList.numOfPages
      ) {
        context.commit(
          "SET_ACCOUNT_LIST_PAGE_INDEX",
          context.state.accountList.index + 1
        );
      }
    },
    accountListPagePrev(context) {
      if (context.state.accountList.index > 1) {
        context.commit(
          "SET_ACCOUNT_LIST_PAGE_INDEX",
          context.state.accountList.index - 1
        );
      }
    },
    setActivityList(context, value) {
      context.commit("SET_ACTIVITY_LIST", value);
    },
    setSalesCenterMaster(context, value) {
      context.commit("SET_SALES_CENTER_MASTER", value);
    },
    setSalesOfficeMaster(context, value) {
      context.commit("SET_SALES_OFFICE_MASTER", value);
    },
    setWeatherAreaRelationMaster(context, value) {
      context.commit("SET_WEATHER_AREA_RELATION_MASTER", value);
    },
    setMonitoringDate(context, value) {
      context.commit("SET_MONITORING_DATE", value);
    },
    resetMonitoringDate(context) {
      context.commit("SET_MONITORING_DATE", "");
    },
    setAlertLevelClass(context, value) {
      context.commit("SET_ALERT_LEVEL_CLASS", value);
    },
    setMaxPowerClass(context, value) {
      context.commit("SET_MAX_POWER_CLASS", value);
    },
    setAirConditionerIdFlag(context, value) {
      context.commit("SET_AIR_CONDITIONER_ID_FLAG", value);
    },
    setSupplyManagement(context, value) {
      context.commit("SET_SUPPLY_MANAGEMENT", value);
    },
    setSelectedDevice(context, value) {
      context.commit("SET_SELECTED_DEVICE", value);
    },
    setLoading(context, value) {
      context.commit("SET_LOADING", value)
    }
  }
});
